// Shared limits/validation for 3D-model input photos (ar-models-implementation.md §6).
export const ACCEPTED_IMAGE_TYPES = {
  "image/jpeg": [".jpeg", ".jpg"],
  "image/png": [".png"],
  "image/heic": [".heic"],
  "image/heif": [".heif"],
  "image/webp": [".webp"],
};

export const MAX_IMAGE_SIZE = 15 * 1024 * 1024; // 15 MB per file
export const MAX_IMAGES_PER_UPLOAD = 50; // per upload request

// Turn react-dropzone rejections into one friendly, de-duplicated message.
export function describeRejections(rejections) {
  const reasons = new Set();
  (rejections || []).forEach((r) =>
    (r.errors || []).forEach((e) => {
      if (e.code === "file-too-large")
        reasons.add("Each photo must be 15 MB or smaller");
      else if (e.code === "file-invalid-type")
        reasons.add("Only JPEG, PNG, HEIC, HEIF or WEBP images are allowed");
      else if (e.code === "too-many-files")
        reasons.add(
          `You can add at most ${MAX_IMAGES_PER_UPLOAD} photos at once`
        );
      else reasons.add(e.message);
    })
  );
  return [...reasons].join(". ");
}
